/**
 * Contact-instructor form.
 */
import React, { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";

import { BModal } from "components";
import { getUserName } from "utils/string";
import { VButton, VFroala, VText } from "form";
import { actionSendCoachEmail } from "context/action";
import { useAsterController } from "context";

/**
 * Sends a coach email with the learner's message.
 */
const ToInstructor = () => {
  const { t } = useTranslation("common");
  const { courseId } = useParams();

  const [controller, dispatch] = useAsterController();
  const { user, courses } = controller;

  const [open, setOpen] = useState(false);
  const [inputText, setInputText] = useState("");

  const currCourse = useMemo(() => (courses.data || []).find((v) => v.id === courseId) || {}, [courseId, courses.data]);

  /**
   * Sends the composed message to the learner's coach.
   *
   * @returns {void}
   */
  const onSubmit = () => {
    if (inputText) {
      setOpen(false);
      const userTxt = `<b>${getUserName(user)}: ${user.email}</b>`;

      const data = {
        email: currCourse.coach_email,
        name: getUserName(user),
        html: `${userTxt} ${inputText}`,
      };
      actionSendCoachEmail(dispatch, data);
      setInputText("");
    }
  };

  return (
    <>
      <VButton className="flex items-center justify-start mt-6" onClick={() => setOpen(true)} disabled={!currCourse.coach_email}>
        <VText color="secondary">
          <Icon className="mb-0 text-2xl" icon="jam:message-alt-f" />
        </VText>
        <Box className="mx-4 text-start">
          <Box className="flex items-center justify-between">
            <VText className="font-bold text-base" div>
              {t("Need help?")}
            </VText>
          </Box>
          <VText className="text-sm leading-5 text-limit-2" color="secondary" div>
            {t("need help for your training, your trainer answers you")}
          </VText>
        </Box>
      </VButton>

      <BModal open={open} setOpen={setOpen} width="90vw" height="fit-content" className="w-full max-w-3xl max-h-150 p-8">
        <Box className="flex flex-col h-100">
          <VText className="p-4 text-lg font-bold">{t("Send email to trainer")}</VText>
          <VFroala model={inputText} setModel={setInputText} maxCount={1000} className="outline-0 border-0" />
          <Box className="flex justify-center mt-4">
            <VButton variant="outlined" onClick={() => setOpen(false)}>
              {t("Cancel")}
            </VButton>
            <VButton variant="contained" onClick={onSubmit} className="ml-4" disableElevation>
              {t("Send")}
            </VButton>
          </Box>
        </Box>
      </BModal>
    </>
  );
};

export default ToInstructor;
